import api from '../utils/baseUrl';
import axios from 'axios';
import {getCookie} from 'typescript-cookie';

class ProductService {
    async getProducts(role?: string, options?: {skipSubscriptionCheck?: boolean}) {
        try {
            const roleType = role || getCookie('roleType');
            const response = await api.get('/api/products', {
                params: {
                    ...(roleType ? {role: roleType} : {}),
                    ...(options?.skipSubscriptionCheck ? {skipSubscriptionCheck: true} : {})
                }
            });
            return response.data.products ?? {};
        } catch (error) {
            console.error('Error retrieving products:', error);
            if (axios.isAxiosError(error) && error.response) {
                throw error;
            }
        }
    }

    async createSubscription(body: object) {
        try {
            const response = await api.post('/api/subscriptionPlans/', body);
            return response.data ?? {};
        } catch (error) {
            console.error('Error while creating subscription checkout session:', error);
            return [];
        }
    }

    async checkSubscription() {
        try {
            const response = await api.get('/api/subscriptionPlans/status');
            return response.data ?? {};
        } catch (error) {
            console.error('Error while creating subscription checkout session:', error);
            return [];
        }
    }

    async createPortalSession(body: object) {
        try {
            return await api.post('/api/billingPortal/session', body);
        } catch (error) {
            console.error('Error creating portal session:', error);
            if (axios.isAxiosError(error) && error.response) {
                return error.response;
            }
        }
    }
}

export default new ProductService();